import { render } from "./SkuList.vue?vue&type=template&id=12e129ed&scoped=true"
import script from "./SkuList.vue?vue&type=script&lang=js"
export * from "./SkuList.vue?vue&type=script&lang=js"

import "./SkuList.vue?vue&type=style&index=0&id=12e129ed&scoped=true&lang=css"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e129ed"]])

export default __exports__